import { conversationsApi } from 'apis/conversations';

import { BulkModalActionType } from '../types/conversationsBulkModal.types';

/** The available conversations bulk modal actions endpoints. */
export const conversationsBulkModalActionEndpoint: Record<
  Extract<BulkModalActionType, 'add_internal_note'>,
  typeof conversationsApi.endpoints.createConversationWrapupMessageBulk
> &
  Record<
    Extract<BulkModalActionType, 'add_tag' | 'remove_tag'>,
    typeof conversationsApi.endpoints.updateConversationTagBulk
  > &
  Record<
    Extract<BulkModalActionType, 'cancel_csat'>,
    typeof conversationsApi.endpoints.updateConversationCancelCsatBulk
  > &
  Record<
    Extract<BulkModalActionType, 'close'>,
    typeof conversationsApi.endpoints.updateConversationCloseBulk
  > &
  Record<
    Extract<BulkModalActionType, 'send_reply'>,
    typeof conversationsApi.endpoints.createConversationMessageBulk
  > &
  Record<
    Extract<BulkModalActionType, 'transfer_to_queue'>,
    typeof conversationsApi.endpoints.updateConversationQueueTransferBulk
  > &
  Record<
    Extract<BulkModalActionType, 'link'>,
    typeof conversationsApi.endpoints.updateConversationLinkBulk
  > = {
  add_internal_note:
    conversationsApi.endpoints.createConversationWrapupMessageBulk,
  add_tag: conversationsApi.endpoints.updateConversationTagBulk,
  cancel_csat: conversationsApi.endpoints.updateConversationCancelCsatBulk,
  close: conversationsApi.endpoints.updateConversationCloseBulk,
  remove_tag: conversationsApi.endpoints.updateConversationTagBulk,
  send_reply: conversationsApi.endpoints.createConversationMessageBulk,
  transfer_to_queue:
    conversationsApi.endpoints.updateConversationQueueTransferBulk,
  link: conversationsApi.endpoints.updateConversationLinkBulk,
};
